import app from "firebase/compat/app";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";
import "firebase/compat/analytics";
import Config from "./Config";
import Cookies from 'universal-cookie';
import Moment from 'moment';

const cookies = new Cookies();

const configDev = {
  apiKey: "AIzaSyCokZxpXqOc4c1AloJC1Rjl1MDk4BUTOvI",
  authDomain: "quickratesurvey-dev.firebaseapp.com",
  projectId: "quickratesurvey-dev",
  storageBucket: "quickratesurvey-dev.appspot.com",
  messagingSenderId: "919629346482",
  appId: "1:919629346482:web:fc61da9702dd0790293bab"
};

const configProd = {
  apiKey: "AIzaSyBP9o_ywW3R6MEAOmP8diiko42K_dVnzr4",
  authDomain: "quickratesurvey-a121d.firebaseapp.com",
  projectId: "quickratesurvey-a121d",
  storageBucket: "quickratesurvey-a121d.appspot.com",
  messagingSenderId: "1056356721543",
  appId: "1:1056356721543:web:a6aafd6694b7b1394ae922"
};

class Firebase {
  constructor() {
    try {
      if (typeof Firebase.instance === "object") {
        return Firebase.instance;

      } else {
        new Config();
        Firebase.instance = this;
        Firebase.instance.firebase = app.initializeApp(Config.ENV === "DEV" || Config.ENV === "LOCAL" ? configDev : configProd);
        app.analytics().setAnalyticsCollectionEnabled(true);
        return this;
      }
    } catch (r) {
      console.error("Error init firebase: ", r);
    }
  }

  loadCompleteSurvey(config, uid, surveyId, onSuccess, onFail) {
    var db = this.firebase.firestore();
    db.collection("Users").doc(uid).collection("surveys").doc(surveyId).get().then(snap => {
      if (snap.exists) {
        let survey = this.getCompleteData(snap);
        if (cookies.get(surveyId) === undefined) {
          this.createResponse(config, survey, (success) => {
            config.update("idResponse", success);
          })
        }
        this.loadScreens(survey?.ref, (screens) => {
          survey.screens = screens;
          onSuccess(survey);
        }, onFail);
      } else {
        throw "Snap not exists";
      }
    }).catch(onFail);
  }

  loadScreens(surveyRef, onSuccess, onFail) {
    surveyRef
      .collection("screens")
      .where("deleted", "==", false)
      .get().then((screensSnap) => {
        let screens = [];
        if (screensSnap.empty) onSuccess(screens);

        screensSnap.forEach((screenDoc) => {
          let screen = this.getCompleteData(screenDoc);

          this.loadQuestions(screen?.ref, (questions) => {
            screen.questions = questions;
            screens.push(screen);

            if (screens.length === screensSnap.size) {
              this.orderList(screens);
              onSuccess(screens);
            }
          }, onFail);
        });
      }).catch(onFail);
  }

  loadQuestions(screenRef, onSuccess, onFail) {
    screenRef.collection("questions")
      .where("deleted", "==", false)
      .get().then((questionsSnap) => {
        let questions = [];
        if (questionsSnap.empty) onSuccess(questions);

        questionsSnap.forEach((questionDoc) => {
          let question = this.getCompleteData(questionDoc);
          question.freeResponse = null;

          this.loadOptions(question?.ref, (options) => {
            question.options = options;
            questions.push(question);

            if (questions.length === questionsSnap.size) {
              this.orderList(questions);
              onSuccess(questions);
            }
          }, onFail);
        });
      }).catch(onFail);
  }

  loadOptions(questionRef, onSuccess, onFail) {
    questionRef.collection("options")
      .where("deleted", "==", false)
      .get().then((optionsSnap) => {
        let options = [];
        if (optionsSnap.empty) onSuccess(options);

        optionsSnap.forEach((optionDoc) => {
          let option = this.getCompleteData(optionDoc);

          this.loadSuboptions(option?.ref, (suboptions) => {
            option.suboptions = suboptions;
            options.push(option);

            if (options.length === optionsSnap.size) {
              this.orderList(options);
              onSuccess(options);
            }
          }, onFail);
        });
      }).catch(onFail);
  }

  loadSuboptions(optionRef, onSuccess, onFail) {
    optionRef.collection("subOptions")
      .where("deleted", "==", false)
      .get().then((suboptionsSnap) => {
        let suboptions = [];
        if (suboptionsSnap.empty) {
          onSuccess(suboptions);
        } else {
          suboptionsSnap.forEach((suboptionDoc) => {
            let suboption = this.getCompleteData(suboptionDoc);
            suboptions.push(suboption);
            if (suboptions.length === suboptionsSnap.size) {
              this.orderList(suboptions);
              onSuccess(suboptions);
            }

          });
        }
      }).catch(onFail);
  }

  orderList(list) {
    list.sort((elementA, elementB) => {
      let orderA = (elementA.order + 1) || Number.MAX_SAFE_INTEGER;
      let orderB = (elementB.order + 1) || Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    })
  }

  getCompleteData(docSnap) {
    return {
      ref: docSnap.ref,
      path: docSnap.ref.path,
      ...docSnap.data()
    }
  }

  //Obtener la fecha de ultima modificacion
  getDataResponse(config, survey, succes) {
    survey.ref.collection("responses").doc(cookies.get(config.surveyId)).get().then((response) => {
      let responseData = this.getCompleteData(response);
      const fecha = new firebase.firestore.Timestamp(responseData.lastUpdate.seconds, responseData.lastUpdate.nanoseconds).toDate();
      succes(Moment(fecha).format("DD/MM/YYYY"), Moment(fecha).format("HH:mm:ss"))
    })
      .catch((error) => console.error(error));
  }

  //Inicia la Response al cargar la survey i para poder obtener el nombre de la response
  createResponse(config, survey, succes) {
    let date = firebase.firestore.Timestamp.now().toDate();
    let response = {
      "creationDate": date,
      "deleted": false,
      "lastUpdate": date,
      "responseLanguage": config.lang,
      "surveyReference": survey.ref,
      "platform": "PC_WEBAPP", // TODO Check device  PC_WEBAPP / MOBILE_WEBAPP /TABLET_WEBAPP
      "IPAddress": config.IPAddress,
      "MACAddress": config.MACAddress,
    }

    if (config.idResponse == "") {
      if (cookies.get(config.surveyId) !== undefined) {
        this.loadDataResponse(config, survey, date)
        succes(cookies.get(config.surveyId))
      }
      else {
        survey.ref.collection("responses").add(response)
          .then((data) => {
            cookies.set(config.surveyId, data.id, { path: '/', expires: new Date(Date.now() + 2147483647) });
            succes(data.id)
          })
          .catch((error) => console.error(error));
      }
    }
  }

  //Obtener datos de la response
  loadDataResponse(config, survey, date) {
    let response = {
      "lastUpdate": date,
    }
    survey.ref.collection("responses").doc(cookies.get(config.surveyId)).update(response);

    survey.ref.collection("responses").doc(cookies.get(config.surveyId)).collection("answers").get().then((answers) => {
      let arrAnswers = [];
      answers.forEach((answerDoc) => {
        let answer = this.getCompleteData(answerDoc);
        arrAnswers.push(answer)
      })

      this.loadDataQuestions(arrAnswers, survey?.screens, config)
      config.update("arrAnswers", arrAnswers);
    }).catch((error) => console.error(error));
  }

  //Subir las respuestas en cada question
  loadDataQuestions(arrAnswers, arrScreens, config) {
    arrAnswers.forEach((answer) => {
      arrScreens.forEach((screen) => {
        screen.questions.forEach((question) => {
          if (question.ref.id === answer.questionReference.id) {
            this.modifyTypeQuestion(question.type, question, answer)
          }
        })
      })
    })
  }

  //Obtener el tipo de Question i modificar en base eso
  modifyTypeQuestion(type, question, answer) {
    let arraySimple = ["MONOOPTION", "MULTIOPTION", "ICON_OPTIONS", "SATISFACTION", "SATISFACTION_EXTENDED", "YES_NO", "NPS"];
    let arrayText = ["EMAIL", "FREE_TEXT"];
    if (arraySimple.includes(type)) {
      question.options.forEach((optionQ) => {
        answer.options.forEach((optionA) => {
          if (optionQ.ref.id === optionA.optionReference.id) {
            optionQ.selected = true;
            if (optionA.suboptionsResponses != null) {
              optionQ.suboptions.forEach((suboptionQ) => {
                optionA.suboptionsResponses.forEach((suboptionA) => {
                  if (suboptionQ.ref.id === suboptionA.optionReference.id) {
                    suboptionQ.selected = true;
                  }
                })
              })
            }
          }
        })
      })
    }

    if (arrayText.includes(type)) {
      let response = answer.freeResponses;
      question.freeResponse = response;
    }
  }

  //Actualiza el lang en el Firebase
  updateLangResponse(config, lang) {
    let response = {
      "responseLanguage": lang,
    }

    if (config.idResponse !== "") {
      config?.survey?.ref.collection("responses").doc(config.idResponse).update(response)
        .then((data) => {
        })
        .catch((error) => console.error(error));
    }
  }

  //Carga los lenguajes disponibles de la survey
  loadAlternativeLanguages(config) {
    var db = firebase.firestore();
    db.collection("Users").doc(config.uid).get()
      .then((data) => {
        if (!data.data().alternativeLanguages.includes(data.data().language)) {
          let arrayL = data.data().alternativeLanguages;
          arrayL.push(data.data().language);
          config.update("alternativeLanguages", arrayL);
        }
        else {
          config.update("alternativeLanguages", data.data().alternativeLanguages);
        }
      })
      .catch((error) => console.error(error));
  }

  //Carga el modo de vista de los idiomas
  loadLanguageDisplayMode(config) {
    var db = firebase.firestore();
    db.collection("Users").doc(config.uid).get()
      .then((data) => {
        config.update("languageDisplayMode", data.data().languageDisplayMode);
      })
      .catch((error) => console.error(error));
  }

  //Update Response
  updateResponseStart(lang, surveyId, uid) {
    var db = firebase.firestore();
    let response = {
      "responseLanguage": lang,
    }
    db.collection("Users").doc(uid).collection("surveys").doc(surveyId).collection("responses").doc(cookies.get(surveyId)).update(response);
  }

  //Carga el idioma del perfil
  loadLanguageStart(uid, surveyId, succes) {
    var db = firebase.firestore();

    if (cookies.get(surveyId) !== undefined) {
      db.collection("Users").doc(uid).collection("surveys").doc(surveyId).collection("responses").doc(cookies.get(surveyId)).get().then((data) => {
        let responseData = this.getCompleteData(data);
        succes(responseData.responseLanguage)
      }).catch((error) => console.error(error));
    }
    else {
      db.collection("Users").doc(uid).get()
        .then((data) => {
          succes(data.data().language)
        })
        .catch((error) => console.error(error));
    }
  }

  //Carga el nombre de referencia del logo
  loadLogoUid(uid, onSuccess, onFail) {
    var db = firebase.firestore();
    db.collection("Users").doc(uid).get().then((data) => {
      let logoName = data.data().logo;
      if (logoName?.length > 0) {
        this.loadUserImage(uid, logoName, onSuccess);
      }
    }).catch(onFail);
  }

  //Carga el nombre de referencia del background
  loadBackgroundUid(uid, url, onSuccess, onFail) {
    var db = firebase.firestore();
    db.doc(url).get().then((data) => {
      let logoName = data.data().background;
      if (logoName?.length > 0) {
        this.loadUserImage(uid, logoName, onSuccess);
      }
    }).catch(onFail);
  }

  //Al seleccionar una respuesta i avanzar a la siguiente se ejecuta el insert de la respuesta echa
  insertResponse(config, question, selectedOptions, updateQuestion, indexQuestion, freeResponse, empty) {
    let answer = {
      "empty": empty,
      "freeResponses": freeResponse,
      options: selectedOptions,
      "questionReference": question.ref
    }
    console.log(config)

    config.survey.ref.collection("responses/" + config.idResponse + "/answers").add(answer)
      .then((data) => {
        console.log(data)
        updateQuestion(indexQuestion, "idAnswer", data.id);
        console.log(config)
      })
      .catch((error) => console.error(error));
  }

  //Al seleccionar una respuesta ya echa anteriormente i avanzar a la siguiente se ejecuta el insert de la respuesta echa
  updateResponse(config, question, selectedOptions, freeResponse, empty) {
    let answer = {
      "freeResponses": freeResponse,
      options: selectedOptions,
      "questionReference": question.ref
    }

    config.survey.ref.collection("responses/" + config.idResponse + "/answers").doc(question.idAnswer).update(answer)
      .then((data) => {
        console.log(data)
        console.log(config)
      })
      .catch((error) => console.error(error));
  }

  runWhenSignUp(action) {
    this.firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        action();
      }
    });
  }

  loadUserImageFromFolder(folder, imageName, success) {
    this.runWhenSignUp(() => {
      let ref = this.firebase.storage().ref().child(`users/${Firebase.user.uid}/${folder}/${imageName}`);
      this.loadImage(ref, success);
    });
  }

  loadUserImage(folder, imageName, success) {
    let ref = this.firebase.storage().ref().child(`users/${folder}/${imageName}`);
    this.loadImage(ref, success);
  }

  loadImage(ref, success) {
    this.firebase
      .storage()
      .refFromURL(ref)
      .getDownloadURL()
      .then((url) => { success(url) })
      .catch((error) => console.error(error));
  }

  uploadImage(image, success) {
    let ref = this.firebase.storage().ref().child(`${Firebase.user.uid}/${this.createUid()}`);
    ref.put(image).then(function (snapshot) {
      let imgRef = `gs://${snapshot.metadata.bucket}/${snapshot.metadata.fullPath}`;
      success(imgRef);
    });
  }

  createUid(length = 20) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  //Obtener UID
  getUid() {
    return firebase?.auth()?.currentUser?.uid;
  }

  //Obtener RGPD
  getRGPD(uid, onSuccess, onFail) {
    this.getUserRGPD(uid, (data) => {
      if (data != null) {
        onSuccess(data);
      } else {
        this.getUserRGPD("default", onSuccess, onFail);
      }
    }, onFail);
  }

  getUserRGPD(uid, onSuccess, onFail) {
    var db = this.firebase.firestore();
    db.collection("Users")
      .doc(uid)
      .collection("pages")
      .doc("RGPD")
      .get()
      .then(docSnap => {
        let data = this.getCompleteData(docSnap)
        onSuccess(data);
      }).catch(onFail);
  }

}

export default Firebase;
